export const speakers = [
  {
    name: 'Вадим Янгиров',
    role: 'Основатель Казанского марафона, TIMERMAN и EthnoRun',
    initials: 'ВЯ'
  },
  {
    name: 'Линар Хуснуллин',
    role: 'Сооснователь KazanExpress, Uzum Market и Teez',
    initials: 'ЛХ'
  },
  {
    name: 'Азат Назмутдинов',
    role: 'Основатель сети «Кыстыбый» и KSTB tatar-food',
    initials: 'АН'
  },
  {
    name: 'Алексей Локонцев',
    role: 'Основатель TOPGUN, COLIZEUM и TOPRACING',
    initials: 'АЛ'
  },
  {
    name: 'Тимур Каримбаев',
    role: 'Основатель Chatium, сооснователь GetCourse',
    initials: 'ТК'
  },
  {
    name: 'Ильяс Гимадов',
    role: 'Девелопер, основатель проектов «Тёплое место» и «Алтын»',
    initials: 'ИГ'
  }
];

export const industries = [
  'IT и ИИ',
  'Маркетинг',
  'Финансы',
  'Девелопмент',
  'Производство',
  'HoReCa',
  'Ритейл и e-commerce',
  'Образование',
  'Медицина',
  'HR',
  'Логистика',
  'Консалтинг',
  'Другое'
];
